import React from "react";
import Layout from "../../components/shared/Layout/Layout";
import SchoolPerformanceViewResults from "../../components/SchoolPerformanceViewResults/SchoolPerformanceViewResults";

const ViewSchoolPerformancePage = () => {
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Layout title={`View School Performance`}>
        <SchoolPerformanceViewResults />
      </Layout>
    </div>
  );
};

export default ViewSchoolPerformancePage;
